<div class="row">
  <div class="col-12">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="d-flex flex-wrap align-items-center">
        @for (filter of filters; track filter) {
          <div class="me-2 mb-2">
            <next-slicer
              #slicer
              selectMode="multiple"
              [title]="filter.label"
              placeholder="Search"
              (onSlicerChange)="onSlicerChange(filter, $event)"
              (onSlicerClose)="onSlicerClose($event)"
              [clearFilters]="resetFilters"
              optionsLabelKey="label"
              optionsValueKey="value"
              [slicerValues]="filter.values"
              [field]="filter.field"
              [isLoading]="filter.isLoading"
            ></next-slicer>
          </div>
        }
        <div class="me-2 mb-2">
          <nb-select
            [selected]="dateRange"
            (selectedChange)="onDateRangeChange($event)"
            placeholder="Date Range..."
            size="small"
            style="min-width: 140px"
            aria-label="Date Range"
            >
            <nb-option value="rolling_12">Rolling 12</nb-option>
            <nb-option value="all_time">All Time</nb-option>
            <nb-option value="today">Today</nb-option>
            <nb-option value="this_week">This Week</nb-option>
            <nb-option value="last_week">Last Week</nb-option>
            <nb-option value="this_month">This Month</nb-option>
            <nb-option value="last_month">Last Month</nb-option>
            <nb-option value="this_year">This Year</nb-option>
            <nb-option value="last_year">Last Year</nb-option>
            <nb-option value="custom_range">Custom Range</nb-option>
          </nb-select>
        </div>
        @if (dateRange === 'custom_range') {
          <div class="me-2 mb-2">
            <input
              nbInput
              fieldSize="small"
              [nbDatepicker]="startDatePicker"
              placeholder="Start Date"
              [(ngModel)]="customStartDate"
              (ngModelChange)="onCustomDateChange()"
              style="width: 120px"
              aria-label="Start Date"
              />
            <nb-datepicker #startDatePicker></nb-datepicker>
          </div>
        }
        @if (dateRange === 'custom_range') {
          <div class="me-2 mb-2">
            <input
              nbInput
              fieldSize="small"
              [nbDatepicker]="endDatePicker"
              placeholder="End Date"
              [(ngModel)]="customEndDate"
              (ngModelChange)="onCustomDateChange()"
              style="width: 120px"
              aria-label="End Date"
              />
            <nb-datepicker #endDatePicker></nb-datepicker>
          </div>
        }
        @if (showClearFilter) {
          <div class="mb-2">
            <button nbButton ghost status="primary" (click)="clearFilters()">
              Clear Filters
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
